import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { Structure } from '../../_models';

@Component({

  selector: 'app-templates-table',
  templateUrl: './templates-table.component.html',
  styleUrls: ['./templates-table.component.css']
})

export class TemplatesTableComponent implements OnChanges {

  dataSource: any = new MatTableDataSource([]);
  displayedColumns: Structure[] = [];
  validate: boolean;

  @Input() source: Record<string, any>[];
  @Input() columns: Structure[];
  @Input() validateData: boolean;

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.columns && changes.columns.currentValue) {
        this.displayedColumns = changes.columns.currentValue;      
      }     

      if (changes.source && changes.source.currentValue !== undefined) {
        this.dataSource = changes.source.currentValue || [];
      }
      this.validate = changes.validateData == undefined ? false : changes.validateData.currentValue;
    }
  }

}